<template>
  <div class="upload-cover-wrap">
    <div class="img" :style="{width: `${img_width}px`,height: `${img_height}px`}" v-if="cover">
      <img :src="cover" alt />
      <div class="img-shadow">
        <!--<i class="el-icon-zoom-in deal-item" title="预览" @click="preview()"></i>-->
        <!-- <i class="el-icon-crop deal-item" title="裁剪" @click="crop()"></i> -->
        <i class="el-icon-delete deal-item" title="删除" @click="delImg()"></i>
      </div>
      <div class="empty-img" v-loading="uploadLoading">
        <i class="el-icon-picture"></i>
      </div>
    </div>
    <div class="upload-btn-wrap">
      <el-upload
        class="upload-demo"
        action="/admin/upload/image"
        :show-file-list="false"
        name="imageFile"
        :on-success="uploadSuccess"
        :on-error="uploadError"
      >
        <div
          class="cover"
          :style="{width: `${img_width}px`,height: `${img_height}px`}"
          v-if="!cover"
        >
          <i class="el-icon-plus"></i>
        </div>
      </el-upload>
    </div>
    <!-- 剪切组件 -->
    <!-- <my-cropper
      :isShow.sync="showCropper"
      :ratio="ratio"
      :cropperData="cropperData"
      @updateImg="cropUpdateImg"
    ></my-cropper> -->
  </div>
</template>

<script>
// import singleCropper from "./single-cropper.vue";

export default {
  props: {
    img_width: {
      default: "160"
    },
    img_height: {
      default: "90"
    },
    coverImg: {
      type: String,
      default: ""
    }
  },
  watch: {
    coverImg: {
      //绑定了一个handler方法
      handler(newName, oldName) {
        this.cover = newName;
      },
      immediate: true
    }
  },
  computed: {
    ratio() {
      //比例
      return this.img_width / this.img_height;
    }
  },
  data() {
    return {
      cover: "",
      uploadLoading: false,
      showCropper: false,
      cropperData: {
        url: ""
      }
    };
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      // console.log(response);
      this.cover = response.result.url;
      this.cropperData.url = response.result.url;
      this.$emit("uploadSuccess", response.result.url);
    },
    uploadError() {
      this.$message.error("上传失败");
    },
    preview() {},
    crop() {
      this.cropperData.url = this.cover;
      this.showCropper = true;
    },
    delImg() {
      this.cover = "";
      this.$emit("uploadSuccess", this.cover);
    },
    cropUpdateImg(data) {
      //剪切后的图像返回给父组件
      this.cover = data.url;
      this.$emit("uploadSuccess", data.url);
    }
  },
  components: {
    // "my-cropper": singleCropper
  }
};
</script>

<style lang="less" scoped>
.upload-cover-wrap {
  display: inline-flex;
  justify-content: space-between;
  vertical-align: top;
  & + .upload-cover-wrap {
    margin-left: 20px;
  }
} 
.img {
  overflow: hidden;
  position: relative;
  &:hover {
    .img-shadow {
      display: flex;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}

.empty-img {
  width: 100%;
  height: 100%;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.img-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  justify-content: center;
  align-items: center;
}

.deal-item {
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    color: #369ad1;
  }
  & + .deal-item {
    margin-left: 20px;
  }
}

.upload-btn-wrap {
  //   margin-left: 10px;
  // width: 120px;
  .cover {
    // width: 100px;
    // height: 100px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #dcdfe6;
    color: #999999;
    &:hover {
      color: #369ad1;
      border-color: #369ad1;
    }
  }
  .upload-tips {
    font-size: 12px;
    line-height: 20px;
    color: @gray;
  }
}
</style>
